import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheIngenieurIA = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🤖 Recruter un Ingénieur en Intelligence Artificielle
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          L’Ingénieur en Intelligence Artificielle conçoit, développe et déploie des systèmes capables de simuler l’intelligence humaine. Il travaille sur des algorithmes d’apprentissage automatique (machine learning), de traitement du langage naturel (NLP) ou de vision par ordinateur. Sa mission : automatiser des processus complexes, optimiser les performances et créer de la valeur à partir de la donnée.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Concevoir des architectures d’IA adaptées aux cas d’usage</li>
          <li>Développer des algorithmes d’apprentissage supervisé et non supervisé</li>
          <li>Travailler sur des projets en NLP, computer vision ou recommandation</li>
          <li>Participer à la mise en production des modèles (MLOps, API, déploiement cloud)</li>
          <li>Optimiser les performances des modèles (précision, rapidité, scalabilité)</li>
          <li>Collaborer avec les data scientists, les développeurs et les métiers</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Maîtrise de Python, NumPy, TensorFlow, PyTorch</li>
          <li>Connaissances solides en statistiques, mathématiques et modélisation</li>
          <li>Expérience en NLP, vision par ordinateur ou reinforcement learning</li>
          <li>Notions d’architecture cloud (AWS, GCP, Azure)</li>
          <li>Pratique du versioning (Git), des containers (Docker) et du MLOps</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : issu d’un master en IA / data, premières expérimentations en projet</li>
          <li>Confirmé : déploiement d’algorithmes en environnement réel</li>
          <li>Expert : capable de piloter une stratégie IA, R&D, optimisation à grande échelle</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–700 € / jour</li>
          <li>Senior / Expert : 750–1 000 € / jour, selon secteur (finance, santé, industrie…)</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheIngenieurIA;
